import React from 'react';
import PropTypes from 'prop-types';
import { STIcon } from '../Icons/STIcon';

export const STGlyph = (props) => <STIcon type="st-glyph" {...props} />;

export const STGlyphTertiary = (props) => <STIcon type="st-glyph-tertiary" {...props} />;

STGlyph.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

STGlyphTertiary.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
